import { render, staticRenderFns } from "./list-sort-product.vue?vue&type=template&id=7404b6e8&scoped=true"
import script from "./list-sort-product.vue?vue&type=script&lang=js"
export * from "./list-sort-product.vue?vue&type=script&lang=js"
import style0 from "./list-sort-product.vue?vue&type=style&index=0&id=7404b6e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7404b6e8",
  null
  
)

export default component.exports